// 9fbef606107a605d69c0edbcd8029e5d
import constants from './CarouselTab.constants';

export const carouselTabDataReq = (payload = {}) => {
  return {
    type: constants.CAROUSEL_TAB_REQ,
    payload,
  };
};

export const carouselTabDataSuccess = (payload = {}) => {
  return {
    type: constants.CAROUSEL_TAB_SUCCESS,
    payload,
  };
};

export const carouselTabDataFail = (payload = {}) => {
  return {
    type: constants.CAROUSEL_TAB_FAIL,
    payload,
  };
};

export default {
  carouselTabDataReq,
  carouselTabDataSuccess,
  carouselTabDataFail,
};
